import { Stack } from '@mui/material';

import tomiLogoUrl from '@images/tomi-logo.png';

const Logo = () => (
    <Stack component='header' alignItems='flex-start' justifyContent='center'>
        <img src={tomiLogoUrl} alt='Tomi Logo' style={{ height: 33 }} />
    </Stack>
);

export default Logo;
